import { ref } from 'vue'

export function useScaleManagement() {
  // 缩放相关
  const scaleValue = ref(100)
  const scaleMax = ref(200)
  const scaleMin = ref(50)

  // 改变缩放
  const changeScale = (big: boolean, printInstance: any) => {
    let newScaleValue = scaleValue.value
    if (big) {
      newScaleValue += 10
      if (newScaleValue > scaleMax.value) newScaleValue = scaleMax.value
    } else {
      newScaleValue -= 10
      if (newScaleValue < scaleMin.value) newScaleValue = scaleMin.value
    }
    if (printInstance) {
      // scaleValue: 放大缩小值, false: 不保存(不传也一样), 如果传 true, 打印时也会放大
      printInstance.zoom(newScaleValue / 100)
      scaleValue.value = Math.round(newScaleValue)
    }
  }

  // 直接设置缩放值
  const changeScaleHandler = (scale: number, printInstance: any) => {
    if (printInstance) {
      printInstance.zoom(scale)
      scaleValue.value = Math.round(scale * 100)
    }
  }

  // 重置缩放
  const resetScale = (printInstance: any) => {
    if (printInstance) {
      printInstance.zoom(1)
      scaleValue.value = 100
    }
  }

  return {
    scaleValue,
    scaleMax,
    scaleMin,
    changeScale,
    changeScaleHandler,
    resetScale,
  }
}
